import useDi from '../useDi'

import Token from '@/di/di.token'

export default function useSessionService() {
  const { container } = useDi()
  const service = container.get(Token.SESSION_SERVICE)
  return { service }
}
